export default "__VITE_ASSET__Cds2PA31__"